module.exports = __webpack_public_path__ + "static/img/14000759.9fa27ffd.png";